import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import useNfcCard from 'hooks/useNfcCard';
import useNfcCardBalance from 'hooks/useNfcCardBalance';

import NfcCardBalancePanel from 'components/NfcCardBalancePanel';
import NfcCardHeader from 'components/NfcCardHeader';
import ScreenContainer from 'components/containers/ScreenContainer';

/**
 * The balance of one card: what it holds, a load and a reset to zero. Its movements have a
 * screen of their own.
 */
export default function NfcCardBalanceScreen() {
	const { t } = useTranslation();

	const { cardId = '' } = useParams<{ cardId: string }>();

	const { card, loading } = useNfcCard(cardId);

	const balance = useNfcCardBalance(cardId);

	return (
		<ScreenContainer title={t('nfc:balance')}>
			<NfcCardHeader card={card} loading={loading} />

			{/* Read again after every load or reset, whatever came of it: a load whose answer was lost may have gone through */}
			<NfcCardBalancePanel
				cardId={cardId}
				balance={balance.balance}
				loading={balance.loading}
				failed={balance.failed}
				onBalance={balance.setBalance}
				onChanged={balance.refetch}
			/>
		</ScreenContainer>
	);
}
